import { Configuration, LogLevel } from "@azure/msal-browser";

// Validación de variables de entorno requeridas
const requiredEnvVars = [
  "REACT_APP_CLIENT_ID",
  "REACT_APP_TENANT_ID",
  "REACT_APP_REDIRECT_URI",
  "REACT_APP_POST_LOGOUT_REDIRECT_URI",
] as const;

requiredEnvVars.forEach((key) => {
  if (!process.env[key]) {
    throw new Error(
      `Falta la variable de entorno ${key}. Verifica tu archivo .env y reinicia el servidor.`
    );
  }
});

// =========================
// Configuración MSAL
// =========================
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI!,
    postLogoutRedirectUri:
      process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI!,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_level, message, containsPii) => {
        if (!containsPii) {
          console.debug(message);
        }
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

// =========================
// LOGIN (solo identidad)
// =========================
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

// =========================
// TOKEN PARA TU API
// =========================
export const apiTokenRequest = {
  scopes: [
    "api://63234f1d-b8d4-44ce-b528-030af8b0c36c/access_as_user",
  ],
};

// =========================
// TOKEN PARA MICROSOFT GRAPH (opcional)
// =========================
export const graphTokenRequest = {
  scopes: ["api://63234f1d-b8d4-44ce-b528-030af8b0c36c/access_as_user"],
};

// =========================
// Microsoft Graph endpoint
// =========================
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};